export const basicTransitionMetrics = [
    {
        name: "co2e_kg_footprint_total_perloan",
        displayName: "Carbon Footprint per Loan",
        units: "CO\u2082e kg"
    },
    {
        name: "average_emissions_intensity",
        displayName: "Emissions Intensity",
        units: `CO\u2082e kg/ft\u00B2`
    },
    {
        name: "co2e_kg_footprint_pcafattrib_perloan",
        displayName: "PCAF Financed Emissions",
        units: "CO\u2082e kg"
    },
]

export function cohortName(metricName) {
    return `cohort_${metricName}`
}

export function hasData(metric, data) {
    return data && data[metric.name] !== null && data[metric.name] !== undefined
}
